import AmortizationSchedule from "underwriter_dashboard/hurdle_editors/AmortizationSchedule";
import AppraisalReport from "underwriter_dashboard/hurdle_editors/AppraisalReport";
import AssetSummary from "underwriter_dashboard/hurdle_editors/AssetSummary";
import BorrowerRateLock from "underwriter_dashboard/hurdle_editors/BorrowerRateLock/BorrowerRateLock";
import CashCloseSummary from "underwriter_dashboard/hurdle_editors/CashCloseSummary/CashCloseSummary";
import ClosingExplanations from "underwriter_dashboard/hurdle_editors/ClosingExplanations";
import ClosingSummary from "underwriter_dashboard/hurdle_editors/ClosingSummary";
import Conditions from "underwriter_dashboard/hurdle_editors/Conditions";
import ConflictOfInterest from "underwriter_dashboard/hurdle_editors/ConflictOfInterest";
import ContactInfo from "underwriter_dashboard/hurdle_editors/ContactInfo";
import CQMBasicInfoReview from "underwriter_dashboard/hurdle_editors/CQMBasicInfoReview";
import CQMDocMagicReview from "underwriter_dashboard/hurdle_editors/CQMDocMagicReview";
import CQMMiscInfoReview from "underwriter_dashboard/hurdle_editors/CQMMiscInfoReview";
import CreditReportPull from "underwriter_dashboard/hurdle_editors/CreditReportPull";
import CreditScorePricing from "underwriter_dashboard/hurdle_editors/CreditScorePricing";
import CreditSummary from "underwriter_dashboard/hurdle_editors/CreditSummary";
import Declarations from "underwriter_dashboard/hurdle_editors/Declarations";
import Default from "underwriter_dashboard/hurdle_editors/Default";
import DesktopUnderwriter from "underwriter_dashboard/hurdle_editors/DesktopUnderwriterHurdle";
import DisclosureApr from "underwriter_dashboard/hurdle_editors/DisclosureApr";
import DisclosureEntities from "underwriter_dashboard/hurdle_editors/DisclosureEntities";
import DisclosureRegeneration from "underwriter_dashboard/hurdle_editors/DisclosureRegeneration";
import DisclosureRequestLintResults from "underwriter_dashboard/hurdle_editors/DisclosureRequestLintResults";
import Disclosures from "underwriter_dashboard/hurdle_editors/Disclosures";
import DocmagicWarnings from "underwriter_dashboard/hurdle_editors/DocmagicWarnings";
import Documents from "underwriter_dashboard/hurdle_editors/Documents";
import Employment from "underwriter_dashboard/hurdle_editors/Employment";
import Escrows from "underwriter_dashboard/hurdle_editors/Escrows";
import Explanations from "underwriter_dashboard/hurdle_editors/Explanations";
import Fees from "underwriter_dashboard/hurdle_editors/Fees";
import FinancialReporting from "underwriter_dashboard/hurdle_editors/FinancialReporting";
import Flags from "underwriter_dashboard/hurdle_editors/Flags";
import FloodCertification from "underwriter_dashboard/hurdle_editors/FloodCertification";
import Fraud from "underwriter_dashboard/hurdle_editors/Fraud";
import Funding from "underwriter_dashboard/hurdle_editors/Funding";
import HazardInsurance from "underwriter_dashboard/hurdle_editors/HazardInsurance";
import History from "underwriter_dashboard/hurdle_editors/History";
import IncomeDocumentsReview from "underwriter_dashboard/hurdle_editors/IncomeDocumentsReview";
import IncomeSummary from "underwriter_dashboard/hurdle_editors/IncomeSummary";
import IncomeSummaryTax from "underwriter_dashboard/hurdle_editors/IncomeSummaryTax";
import InvestorRateLock from "underwriter_dashboard/hurdle_editors/InvestorRateLock/InvestorRateLock";
import LoanFileWorksheet from "underwriter_dashboard/hurdle_editors/LoanFileWorksheet";
import LoanProduct from "underwriter_dashboard/hurdle_editors/LoanProduct";
import LoanProductScenario from "underwriter_dashboard/hurdle_editors/LoanProductScenario";
import Messages from "underwriter_dashboard/hurdle_editors/Messages";
import MortgageInsuranceSummary from "underwriter_dashboard/hurdle_editors/MortgageInsuranceSummary";
import NewIncomeEditor from "underwriter_dashboard/hurdle_editors/Income";
import OwnerOccupancy from "underwriter_dashboard/hurdle_editors/OwnerOccupancy";
import PersonalInfo from "underwriter_dashboard/hurdle_editors/PersonalInfo";
import PointsAndCredits from "underwriter_dashboard/hurdle_editors/PointsAndCredits";
import PostClosingDocs from "underwriter_dashboard/hurdle_editors/PostClosingDocs";
import Prepaids from "underwriter_dashboard/hurdle_editors/Prepaids";
import PropertyCondition from "underwriter_dashboard/hurdle_editors/PropertyCondition";
import PropertyType from "underwriter_dashboard/hurdle_editors/PropertyType";
import SalariedIncome from "underwriter_dashboard/hurdle_editors/Income[Old]/SalariedIncome";
import SandboxScenario from "underwriter_dashboard/hurdle_editors/SandboxScenario";
import SecondLien from "underwriter_dashboard/hurdle_editors/SecondLien";
import SpecialSituations from "underwriter_dashboard/hurdle_editors/SpecialSituations";
import SubjectPropertyReport from "underwriter_dashboard/hurdle_editors/SubjectPropertyReport";
import Tasks from "underwriter_dashboard/hurdle_editors/Tasks";
import TaxTranscripts from "underwriter_dashboard/hurdle_editors/TaxTranscripts";
import Title from "underwriter_dashboard/hurdle_editors/Title";
import TitleCommitment from "underwriter_dashboard/hurdle_editors/TitleCommitment";
import TransactionTerms from "underwriter_dashboard/hurdle_editors/TransactionTerms";
import UnderwritingHub from "underwriter_dashboard/hurdle_editors/UnderwritingHub";
import UnderwritingSummary from "underwriter_dashboard/hurdle_editors/UnderwritingSummary";
import VerbalVerificationOfEmployment from "underwriter_dashboard/hurdle_editors/VerbalVerificationOfEmployment";
import VALoans from "underwriter_dashboard/hurdle_editors/VALoans";
import Vesting from "underwriter_dashboard/hurdle_editors/Vesting";
import WrittenVerificationOfEmployment from "underwriter_dashboard/hurdle_editors/WrittenVerificationOfEmployment";
import { HurdleTab } from "../shared/HurdleTabGroup";

const hurdleNameToEditor = {
  AmortizationSchedule,
  AppraisalReportHurdle: AppraisalReport,
  AssetSummaryHurdle: AssetSummary,
  BorrowerRateLockHurdle: BorrowerRateLock,
  CashCloseSummaryHurdle: CashCloseSummary,
  ClosingExplanationsHurdle: ClosingExplanations,
  ClosingSummaryHurdle: ClosingSummary,
  ConditionsHurdle: Conditions,
  ConflictOfInterestHurdle: ConflictOfInterest,
  ContactInfoHurdle: ContactInfo,
  CQMBasicInfoReviewHurdle: CQMBasicInfoReview,
  CQMDocMagicReviewHurdle: CQMDocMagicReview,
  CQMMiscInfoReviewHurdle: CQMMiscInfoReview,
  CreditReportPullHurdle: CreditReportPull,
  CreditScorePricingHurdle: CreditScorePricing,
  CreditSummaryHurdle: CreditSummary,
  DeclarationsHurdle: Declarations,
  DesktopUnderwriterHurdle: DesktopUnderwriter,
  DisclosureAPRMismatchHurdle: DisclosureApr,
  DisclosureEntitiesHurdle: DisclosureEntities,
  DisclosureGeneration: Disclosures,
  DisclosureRegenerationHurdle: DisclosureRegeneration,
  DisclosureRequestLintResultsHurdle: DisclosureRequestLintResults,
  DocmagicWarningsHurdle: DocmagicWarnings,
  DocumentsHurdle: Documents,
  EmploymentHurdle: Employment,
  EscrowsHurdle: Escrows,
  ExplanationsHurdle: Explanations,
  FeesHurdle: Fees,
  FinancialReporting,
  FlagsHurdle: Flags,
  FloodCertificationHurdle: FloodCertification,
  FraudHurdle: Fraud,
  FundingHurdle: Funding,
  HazardInsuranceHurdle: HazardInsurance,
  HistoryHurdle: History,
  Income: NewIncomeEditor,
  IncomeDocumentsReviewHurdle: IncomeDocumentsReview,
  IncomeSummaryHurdle: IncomeSummary,
  InvestorRateLockHurdle: InvestorRateLock,
  LoanFileWorksheetHurdle: LoanFileWorksheet,
  LoanProductHurdle: LoanProduct,
  LoanProductScenario,
  MessagesHurdle: Messages,
  MortgageInsuranceSummaryHurdle: MortgageInsuranceSummary,
  OwnerOccupancyHurdle: OwnerOccupancy,
  PersonalInfoHurdle: PersonalInfo,
  PointsAndCredits,
  PostClosingDocsHurdle: PostClosingDocs,
  PrepaidsHurdle: Prepaids,
  PropertyConditionHurdle: PropertyCondition,
  PropertyTypeHurdle: PropertyType,
  SalariedIncomeAnalysisHurdle: SalariedIncome,
  SandboxScenario,
  SecondLienHurdle: SecondLien,
  SpecialSituationsHurdle: SpecialSituations,
  SubjectPropertyReportHurdle: SubjectPropertyReport,
  TasksHurdle: Tasks,
  TaxReturnIncomeAnalysisHurdle: IncomeSummaryTax,
  TaxTranscriptsHurdle: TaxTranscripts,
  TitleCommitmentHurdle: TitleCommitment,
  TitleHurdle: Title,
  TransactionTermsHurdle: TransactionTerms,
  UnderwritingHubHurdle: UnderwritingHub,
  UnderwritingSummaryHurdle: UnderwritingSummary,
  VerbalVerificationOfEmploymentHurdle: VerbalVerificationOfEmployment,
  VALoans,
  VestingHurdle: Vesting,
  WrittenVerificationOfEmploymentHurdle: WrittenVerificationOfEmployment,
};

export const getEditorForHurdle = (name: string) => hurdleNameToEditor[name] || Default;

interface HurdleNameTabLabelPair {
  name: string;
  label: string;
  link: string;
}

interface TabGroup {
  [groupName: string]: HurdleNameTabLabelPair[];
}

const hurdleTabGroups: TabGroup = {
  income: [
    {
      label: "Income summary",
      link: "summary",
      name: "IncomeSummaryHurdle",
    },
    {
      label: "Document review",
      link: "document-review",
      name: "IncomeDocumentsReviewHurdle",
    },
    {
      label: "Salaried income",
      link: "salaried",
      name: "SalariedIncomeAnalysisHurdle",
    },
    {
      label: "Tax return income",
      link: "tax-return",
      name: "TaxReturnIncomeAnalysisHurdle",
    },
  ],
};

export const getHurdleTabGroup = (name: string): null | HurdleTab[] => {
  const group = hurdleTabGroups[name];
  if (!group) {
    return null;
  }
  return group.map(({ label, link, name }) => ({
    label,
    link,
    name,
    component: getEditorForHurdle(name),
  }));
};
